module.exports = __webpack_public_path__ + "static/media/image08.4f0adc59.png";